const getSteps = ({
  bmcVision, canModify, isMVP, canShowBoard,
}) => (section, intl, user) => {
  const steps = [];

  steps.push(
    {
      target: '.bmc-row-container',
      content: intl.formatMessage({ id: 'tooltips.igbmc_intro' }, { name: user.shortName || '' }),
      placement: 'auto',
      disableBeacon: true,
    },
    {
      target: '.bmc-stages-container',
      content: intl.formatMessage({ id: 'tooltips.progress_indicator' }),
      placement: 'auto',
    },

    {
      target: '.stage-item-observational_suggests',
      content: intl.formatMessage({ id: 'tooltips.observational_suggests' }),
      placement: 'auto',
    },
    {
      target: '.stage-item-first_user_suggests',
      content: intl.formatMessage({ id: 'tooltips.first_user_suggests' }),
      placement: 'auto',
    },
    {
      target: '.stage-item-user_first_group_suggests',
      content: intl.formatMessage({ id: 'tooltips.user_first_group_suggests' }),
      placement: 'auto',
    },
    {
      target: '.stage-item-focus_group_suggests',
      content: intl.formatMessage({ id: 'tooltips.focus_group_suggests' }),
      placement: 'auto',
    },
    {
      target: '.stage-item-know_how_suggests',
      content: intl.formatMessage({ id: 'tooltips.know_how_suggests' }),
      placement: 'auto',
    },
    {
      target: '.stage-item-early_adopters_suggests',
      content: intl.formatMessage({ id: 'tooltips.early_adopters_suggests' }),
      placement: 'auto',
    },
    {
      target: '.stage-item-first_client_suggests',
      content: intl.formatMessage({ id: 'tooltips.first_client_suggests' }),
      placement: 'auto',
    },
    {
      target: '.stage-item-free_suggests',
      content: intl.formatMessage({ id: 'tooltips.free_suggests' }),
      placement: 'auto',
    },
  );

  if (!bmcVision) {
    steps.push({
      target: '.bmc-filter-row',
      content: intl.formatMessage({ id: 'tooltips.filters' }),
    });
  }

  steps.push(
    {
      target: '.lane-customer_segments',
      content: intl.formatMessage({ id: 'tooltips.customer_segments' }),
      placement: 'auto',
    },
    {
      target: '.lane-key_propositions',
      content: intl.formatMessage({ id: 'tooltips.value_proposition' }),
      placement: 'auto',
    },
    {
      target: '.lane-customer_relationships',
      content: intl.formatMessage({ id: 'tooltips.customer_relationships' }),
      placement: 'auto',
    },
    {
      target: '.lane-channels',
      content: intl.formatMessage({ id: 'tooltips.channels' }),
      placement: 'auto',
    },
    {
      target: '.lane-key_activities',
      content: intl.formatMessage({ id: 'tooltips.key_activities' }),
      placement: 'auto',
    },
    {
      target: '.lane-key_resources',
      content: intl.formatMessage({ id: 'tooltips.key_resources' }),
      placement: 'auto',
    },
    {
      target: '.lane-key_partners',
      content: intl.formatMessage({ id: 'tooltips.key_partners' }),
      placement: 'auto',
    },
    {
      target: '.lane-cost_structure',
      content: intl.formatMessage({ id: 'tooltips.cost_structure' }),
      placement: 'auto',
    },
    {
      target: '.lane-revenue_streams',
      content: intl.formatMessage({ id: 'tooltips.revenue_streams' }),
      placement: 'auto',
    },
  );

  if ($('.lane-customer_segments .btn')) {
    steps.push({
      target: '.lane-customer_segments .btn',
      content: intl.formatMessage({ id: 'tooltips.new_card_btn' }),
      placement: 'auto',
    });
  }

  if ($('.bmc-step-by-step-row .btn')) {
    steps.push({
      target: '.bmc-step-by-step-row .btn',
      content: intl.formatMessage({ id: 'tooltips.step_by_step' }),
      placement: 'auto',
    });
  }

  if ($('.card')) {
    steps.push({
      target: '.card',
      content: intl.formatMessage({ id: 'tooltips.card_edit' }),
      placement: 'auto',
    });
  }

  steps.push({
    target: '#igbmc-learn-btn',
    content: intl.formatMessage({ id: 'tooltips.igbmc_fin' }),
    placement: 'auto',
  });

  return steps;
};

const TOOLTIPPROPS_CONSTRUCTOR = (bmcTooltipProps = {}) => ({
  getSteps: getSteps(bmcTooltipProps),
  sections: { default: 'default' },
});

export { TOOLTIPPROPS_CONSTRUCTOR };
